
const setBlueBoxOffers = (state, offers) => {
  state.blueBoxOffers = offers;
};

const setAdminOffers = (state, adminOffers) => {
  state.adminOffers = adminOffers;
};

export default {
  setBlueBoxOffers,
  setAdminOffers,
};
